import styled from '@emotion/styled';
export const FormContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2rem;
	max-width: 44rem;
	width: 100%;
	margin: 0 auto;
	justify-content: center;
`;
export const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2rem;
	align-items: center;
`;

export const ImgBox = styled.div`
	width: 11.8rem;
	img {
		width: 100%;
	}
`;

export const ContentBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.8rem;
	align-items: center;
`;
export const Title = styled.p`
	color: #212529;
	font-size: ${(props) => props.theme.fontSize.sizeXl};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: 130%;
	letter-spacing: -0.6px;
`;
export const NextButton = styled.button`
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 100%;
	letter-spacing: -0.6px;
	background-color: ${(props) => props.theme.colors.primary400};
	color: #fff;
	height: 4.4rem;
	padding: 0 1.2rem;
	border: none;
	cursor: pointer;
	&:disabled {
		background-color: #e9ecef;
		color: #adb5bd;
	}
`;

export const SubTitle = styled.p`
	text-align: center;
	color: #212529;
	font-size: ${(props) => props.theme.fontSize.sizeLg};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 140%;
	letter-spacing: -0.6px;
`;
export const SecessionButton = styled.button`
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: #fff;
	color: #495057;
	height: 4rem;
	padding: 0 1.2rem;
	font-size: ${(props) => props.theme.fontSize.sizeSm};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 100%;
	letter-spacing: -0.6px;
	border: none;
	width: 100%;

	cursor: pointer;
	width: fit-content;
`;
export const ButtonBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1.2rem;
	.button_wrap {
		display: flex;
		justify-content: center;
		width: 100%;
	}
`;
